import React from "react";
import SimpleHeader from "../SimpleHeader/SimpleHeader";

const ContactHeader: React.FC = () => {
  return <SimpleHeader title="Contact Us" borderBottom />;
};

export default ContactHeader;
